"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Grid = ({ children, className, noGap, noGutter, cols }) => {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('grid w-full', cols && cols < 12 && cols > 0 ? `grid-cols-${cols}` : 'grid-cols-12', { 'gap-4': !noGap, 'px-2': !noGutter }, className) }, children));
};
exports.Grid = Grid;
